import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

import {PRIVATE, PUBLIC} from '../variables'

const TABLE = '/link/';

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    }
}

// actions
const actions = {

    get({ commit }, params) {
        return axios
            .post(TABLE+'params/'+token(params))
            .then(res => {
                return decode(res.data.data).then((r)=>{
                    if(r) return r[0]
                    else return null
                });
            })
            .catch(err => {
                return null
            });
    },

    insert({ dispatch }, params) {
        return axios
            .post(TABLE+params.id, {
                t: token(params)
            })
            .then(res => {
                return !res.data.errors;
            })
            .catch(err => {
                return false;
            });
    },

}

// mutations
const mutations = {
    
}

function token(params) {
    return JWT.sign({
        exp: Math.floor(Date.now() / 1000) + (60),
        data: params
    }, PRIVATE, { algorithm: 'RS256'});
}

function decode (token) {
    return new Promise(
        function (resolve, reject) {
          JWT.verify(token, PUBLIC, (err, decoded) => {
            if(err)resolve(false);
            else resolve(JWT.decode(token).data);
          });
        }
    );
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/imagens.js